export const NESTED_DISPLACEMENT = 16;

const NEST_TRANSITION = "transform 0.5s cubic-bezier(0.32, 0.72, 0, 1)";

function nestedScale(): number {
  return (window.innerWidth - NESTED_DISPLACEMENT) / window.innerWidth;
}

export function applyNestedTransform(
  el: HTMLElement | null,
  snapOffset: number,
  scale: number,
  nestTranslate: number,
  withTransition: boolean,
): void {
  if (!el) {
    return;
  }
  el.style.transition = withTransition ? NEST_TRANSITION : "none";
  el.style.transform = `translateY(${snapOffset + nestTranslate}px) scale(${scale})`;
}

export function applyNestedOpen(el: HTMLElement | null, snapOffset: number): void {
  applyNestedTransform(el, snapOffset, nestedScale(), -NESTED_DISPLACEMENT, true);
}

export function applyNestedDrag(el: HTMLElement | null, snapOffset: number, percentageDragged: number): void {
  if (percentageDragged < 0) {
    return;
  }
  const initialScale = nestedScale();
  const scale = initialScale + percentageDragged * (1 - initialScale);
  const nestTranslate = -NESTED_DISPLACEMENT + percentageDragged * NESTED_DISPLACEMENT;
  applyNestedTransform(el, snapOffset, scale, nestTranslate, false);
}

export function applyNestedClose(el: HTMLElement | null, snapOffset: number): void {
  applyNestedTransform(el, snapOffset, 1, 0, true);
}

export function clearNestedTransform(el: HTMLElement | null): void {
  if (!el) {
    return;
  }
  el.style.transform = "";
  el.style.transition = "";
}
